import * as React from 'react'

import {
  Box,
  Button,
  Link,
  Modal,
  Space,
  TextBody,
  TextHeading,
  useModalContext,
} from '@ally/metronome-ui'

export const forgotAutoUsernameAndPasswordNumbers = {
  insideUS: '1-888-925-2559',
}

const headingRef = React.createRef<HTMLHeadingElement>()

const ModalContent: React.FC = () => {
  const headingText = "Call us if you've forgotten your Auto password."
  return (
    <>
      <Space mb={24}>
        <TextHeading
          data-testid="help-modal-header"
          size="md"
          tag="h1"
          tabIndex={-1}
          ref={headingRef}
        >
          {headingText}
        </TextHeading>

        <Box mb="md">
          <Link
            allytmln={`${forgotAutoUsernameAndPasswordNumbers.insideUS}`}
            text={forgotAutoUsernameAndPasswordNumbers.insideUS}
            href={`tel:${forgotAutoUsernameAndPasswordNumbers.insideUS.replace(
              '-',
              '',
            )}`}
          />
          <TextBody tag="p" size="sm">
            <Space>
              <TextBody tag="p" size="sm">
                Mon &ndash; Fri 8 am &ndash; 11 pm ET
              </TextBody>
            </Space>
            Sat 9 am &ndash; 7 pm ET
          </TextBody>
        </Box>
      </Space>
    </>
  )
}

const ModalTriggerComponent: React.FC = () => {
  const { setOpen } = useModalContext()

  return (
    <Button
      allytmln="forgotAutoPasswordModal"
      data-testid="help-modal-trigger"
      onClick={(): void => setOpen(true)}
      text="password"
      variant="link"
    />
  )
}

export const ForgotUsernameAndPasswordModal: React.FC = () => (
  <Modal content={<ModalContent />} trigger={<ModalTriggerComponent />} />
)
